module.exports = __webpack_public_path__ + "img/bg-lg-ft.34697b14.jpg";